module.exports = __webpack_public_path__ + "img/ding_3.96e00c15.png";